import {
  api_req_get_tags,
  api_req_get_qty_location_rows,
  api_req_get_location_rows,
/*   api_req_locid_info,
  api_req_locid_edit,
  api_req_locid_delete */
} from "../Locator/LocServices/api_request"

const UPDATE_REQ_TAGS = "UPDATE_REQ_TAGS"
const UPDATE_SEARCH_LOADING = "UPDATE_SEARCH_LOADING"
const UPADTE_FOUND_ROWS_QTY = "UPADTE_FOUND_ROWS_QTY"
const UPADTE_FOUND_ROWS = "UPADTE_FOUND_ROWS"
const TEST = "TEST";
  
  const initialState = {
    isLoading: false,
    tagsDays_req: 180, //days horisont
    //search_str: "",
    //tags_str: null,
    req_tags: null,
    req_found_rows: null,
    req_found_rows_qty: 0, 
    //loc_id_info: null,
    //loc_id_edit: null,
    //loc_id_delete: null,
    //locAlert: {
    msgError: '',
  

  };
  
  const searchReducer = (state = initialState, action) => {
     if (action.type === UPDATE_REQ_TAGS) {
      const {payload} = action
        const stateCopy = {
            ...state,
            req_tags: payload
          };
        return stateCopy;
      }  

      if (action.type === UPDATE_SEARCH_LOADING) {
        const {boolValue} = action
          const stateCopy = {
              ...state,
              isLoading: boolValue
            };
          return stateCopy;
        }

      if (action.type === UPADTE_FOUND_ROWS_QTY) {
        const {qty} = action
          const stateCopy = {
              ...state,
              req_found_rows_qty: qty
            };
          return stateCopy;
        }  
      //UPADTE_FOUND_ROWS req_found_rows payload
      if (action.type === UPADTE_FOUND_ROWS) {
        const {payload} = action
          const stateCopy = {
              ...state,
              req_found_rows: payload
            };
          return stateCopy;
        }          
  
    return state;
  };

  export const updateSearchLoading = (boolValue) => ({ type: UPDATE_SEARCH_LOADING, boolValue});
  export const updateFoundRows = (payload) => ({ type: UPADTE_FOUND_ROWS, payload});

 /*  export const update_loc_simpleFinderMode = (modeName) => ({ type: UPDATE_LOC_SIMPLE_FINDER_MODE, modeName});
  export const update_test = () => ({ type: UPDATE_LOC_SIMPLE_FINDER_MODE});
  export const UPDATE_SEARCH_LOADING = (boolValue) => ({ type: UPDATE_SEARCH_LOADING, boolValue});
  export const update_loc_id = (id) => ({ type: UPDATE_LOC_ID, id});
  export const update_loc_alert = (payload) => ({ type: UPDATE_LOC_ALERT, payload}); */


  export const test = (locationId, chat_id, token) => (dispatch) => {
    //console.log('ggggdisp')
    return dispatch({
/*       type: UPDATE_LOC_ID_INFO,
      locationId: locationId,
      chat_id: chat_id,
      token: token */
    });
  
  };

  export const getTags = (chat_id, token) => (dispatch) => {
    //console.log('getTags thunk')
    //console.log(initialState.tagsDays_req)
    dispatch({type: UPDATE_SEARCH_LOADING, boolValue: true})

    const interval_days = initialState.tagsDays_req;
    return api_req_get_tags(chat_id, interval_days, token)
    .then(
      (response) => {
        //console.log(response.data.result)
        dispatch({type: UPDATE_REQ_TAGS, payload: response.data.result})
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})

        return Promise.resolve();
      },
      (error) => {
        console.log(error.message)
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})
        return Promise.reject();
      }
    )
  };

  export const getQtyLocatorRecords = (chat_id, token, tags, str_search) => (dispatch) => {
    //console.log('getTags thunk')
    //console.log(chat_id, token, tags, str_search)

    dispatch({type: UPDATE_SEARCH_LOADING, boolValue: true})

    return api_req_get_qty_location_rows(chat_id, token, tags, str_search)
    .then(
      (response) => {
        //console.log(response.data.result[0].qty)
        dispatch({type: UPADTE_FOUND_ROWS_QTY, qty: response.data.result[0].qty})
        dispatch({type: UPADTE_FOUND_ROWS, payload: null})
        
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})

        return Promise.resolve();
      },
      (error) => {
        console.log(error.message)
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})
        return Promise.reject();
      }
    )
  };  
//UPADTE_FOUND_ROWS req_found_rows payload
  export const getLocatorRecords = (chat_id, token, tags, str_search) => (dispatch) => {
    //console.log('getTags thunk')
    //console.log(chat_id, token, tags, str_search)

    dispatch({type: UPDATE_SEARCH_LOADING, boolValue: true})

    return api_req_get_location_rows(chat_id, token, tags, str_search)
    .then(
      (response) => {
        //console.log(response.data.result[0])
        dispatch({type: UPADTE_FOUND_ROWS, payload: response.data.result})
        //dispatch({type: UPDATE_REQ_TAGS, payload: response.data.result})
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})

        return Promise.resolve();
      },
      (error) => {
        console.log(error.message)
        dispatch({type: UPDATE_SEARCH_LOADING, boolValue: false})
        
        return Promise.reject();
      }
    )
  };  

  export default searchReducer;  